"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDependenciesFactory = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const dependencies_1 = require("./dependencies");
/**
 * @deprecated please use getInitDependencies instead
 */
exports.initDependenciesFactory = (0, web_ui_framework_1.getInitDependenciesFactory)(dependencies_1.dependencies);
//# sourceMappingURL=initDependenciesFactory.js.map